import React from "react";

import BaseButton from "./BaseButton/BaseButton";

export default function MailWriter({
    email,
    onEmailChange,
    onSubmit,
    disabled = false,
    isSubmitting = false,
}) {
    return (
        <form className="flex-col gap1" onSubmit={onSubmit}>
            <div className="flex-col gap05">
                <label htmlFor="email" style={{ color: "var(--color-text-white)" }}>
                    <strong>Вход по почте</strong>
                </label>
                <input
                    className="w100 font11 txt_rob inp"
                    type="email"
                    id="email"
                    name="email"
                    value={email}
                    onChange={(event) => onEmailChange(event.target.value)}
                    placeholder="Адрес эл. почты"
                    disabled={disabled}
                    required
                />
            </div>

            <BaseButton type="submit" disabled={disabled} showArrow={false} contentAlign="center">
                <span>{isSubmitting ? "Отправляем код..." : "Вход"}</span>
            </BaseButton>
        </form>
    );
}
